
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 3c-4.963 0-9 3.612-9 8.053 0 1.552.494 3.055 1.43 4.355-.177 1.95-.652 3.397-1.342 4.083A.297.297 0 002.3 20c.014 0 .028 0 .042-.003.121-.017 2.944-.42 4.985-1.592 1.16.465 2.394.7 3.673.7 4.963 0 9-3.612 9-8.052C20 6.613 15.963 3 11 3zm-4.2 9.246c-.662 0-1.2-.535-1.2-1.193S6.138 9.86 6.8 9.86c.662 0 1.2.535 1.2 1.193s-.538 1.193-1.2 1.193zm4.2 0c-.662 0-1.2-.535-1.2-1.193S10.338 9.86 11 9.86c.662 0 1.2.535 1.2 1.193s-.538 1.193-1.2 1.193zm4.2 0c-.662 0-1.2-.535-1.2-1.193s.538-1.193 1.2-1.193c.662 0 1.2.535 1.2 1.193s-.538 1.193-1.2 1.193z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_chat.svg